<template>
  <div class="confirmation-block">
    <template v-if="isOkNoAddress">
      <div class="col-md-12 title">{{ $t('tracking.replacing.titleOk') }}</div>
      <div class="col-md-12 description">
        <p>{{ $t('tracking.replacing.okWait') }}</p>
        <p>{{ $t('tracking.replacing.mailIncoming') }}</p>
      </div>
    </template>
    <template v-else-if="isOkWithAddress">
      <div class="col-md-12 title">{{ $t('tracking.replacing.titleOk') }}</div>
      <div class="col-md-12 description">
        <p>{{ $t('tracking.replacing.okWait') }}</p>
        <div>
          <address
            class="replacing-address-container"
            v-if="isOkWithAddress && formattedAddress.length"
          >
            <div v-for="(line, i) in formattedAddress" :key="i" v-html="line"></div>
          </address>
          <button
            class="show-details btn btn-primary"
            v-if="!showParcelshopDetails"
            @click="toggleParcelshopDetails"
            :aria-expanded="showParcelshopDetails.toString()"
          >
            {{ $t('tracking.replacing.showParcelshopDetails') }}
          </button>
          <ParcelshopDetails
            class="col-md-8"
            v-if="showParcelshopDetails"
            :parcelshop="parcelshop"
          />
        </div>
        <p class="col-md-12 replacing-mail">{{ $t('tracking.replacing.mailIncoming') }}</p>
      </div>
    </template>
    <template v-else>
      <div class="col-md-12 title">{{ $t('tracking.replacing.titleKo') }}</div>
      <div class="col-md-12 description">
        <p>
          <b>{{ $t('tracking.replacing.errorTitle') }}</b>
        </p>
        <p>{{ $t('tracking.replacing.retry') }}</p>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ParcelshopDetails from '../../../../parcelshop-picker/src/components/ParcelshopDetails/ParcelshopDetails';

export default {
  components: {
    ParcelshopDetails,
  },
  props: {
    parcelshop: Object,
  },
  data() {
    return {
      showParcelshopDetails: false,
    };
  },
  computed: {
    ...mapState(['confirmationStatus']),
    isOkNoAddress() {
      return this.confirmationStatus === 1;
    },
    isOkWithAddress() {
      return this.confirmationStatus === 2;
    },
    isKo() {
      return this.confirmationStatus === 3;
    },
    formattedAddress() {
      const a = this.parcelshop?.Adresse || {};
      const parts = [
        a.Libelle && `<b>${a.Libelle}</b>`,
        a.AdresseLigne1,
        a.AdresseLigne2,
        (a.CodePostal || a.Code) && a.Ville
          ? `${a.CodePostal} - ${a.Ville}`
          : a.Ville || a.CodePostal,
        a.Pays?.Code,
      ].filter(Boolean);
      return parts;
    },
  },
  methods: {
    toggleParcelshopDetails() {
      this.showParcelshopDetails = !this.showParcelshopDetails;
    },
  },
};
</script>

<style scoped lang="scss">
@import './ConfirmationMessage.scss';
</style>
